






























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { SwDashSwitch, SwDashSwitchOption } from '@libs/unified-ui-framework/src/shared/sw-dash-switch';
import navItems from '@/core/nav-service/nav-data';
import NavIndicator from './nav-indicator.vue';
import { NavIndiRefDimention } from './types';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';

@Component({
  components: {
    SwDashSwitch,
    NavIndicator,
  },
})
export default class SwAppNav extends Vue {

  switchOptions: SwDashSwitchOption[] = navItems;

  cssPrefix: String = 'sw-app-nav';

  showIndicator: boolean = false;

  get currentPath() {
    return this.$route.path.split('/')
    .slice(-1)[0];
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.username))
  username: string;

  get conditionalSwitchItems() {
    return this.username !== undefined ? navItems : navItems.slice(1);
  }

  onSwitchPage(pageId: string) {
    this.$router.push({
      path: `/m/page/${pageId}`,
    });
    /** only after the user clicks on any of these switches, we hide the indicator */
    this.showIndicator = false;
  }

  mounted() {
    this.$nextTick(() => {
      this.showIndicator = true;
    });
    window.addEventListener('resize', this.onResize);

    if (this.conditionalSwitchItems.length === 3 && this.currentPath === 'bill-meter') {
      this.$router.push({
        path: '/m/page/worldwide-attacks',
      });
    }
  }

  updated() {
    this.$nextTick(() => {
      if (this.$refs.navIndi) {
        (this.$refs.navIndi as NavIndicator).updateRefDimention(this.getIndiRefDimention());
      }
    });
  }

  onResize() {
    if (this.$refs.navIndi) {
      (this.$refs.navIndi as NavIndicator).updateRefDimention(this.getIndiRefDimention());
    }
  }

  getIndiRefDimention(): NavIndiRefDimention {
    if (!this.$refs.dashSwitch) {
      return {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      };
    }
    const refEl = (this.$refs.dashSwitch as Vue).$el as HTMLElement;
    return {
      left: refEl.offsetLeft,
      top: refEl.offsetTop,
      width: refEl.offsetWidth,
      height: refEl.offsetHeight,
    };
  }
}
